import { render, staticRenderFns } from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=template&id=3ab99cee&scoped=true"
import script from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=style&index=0&id=3ab99cee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab99cee",
  null
  
)

export default component.exports